import { render, staticRenderFns } from "./ClientUserTreeSelect.vue?vue&type=template&id=f5a9dce2&scoped=true"
import script from "./ClientUserTreeSelect.vue?vue&type=script&lang=js"
export * from "./ClientUserTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a9dce2",
  null
  
)

export default component.exports